import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const fetchHistoricoProdutos = async (
  clienteHistPedidos,
  dataInicial,
  dataFinal,
  token,
  codLoja,
  username,
  password
) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";

  try {
    const response = await workflowAxiosGet(
      `${baseUrl}HISTORICO_PEDIDOS`,
      {
        params: {
          loja: codLoja,
          dt_inicial: dataInicial,
          dt_final: dataFinal,
          cliente: clienteHistPedidos
        }
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar histórico de produtos:", error);
    throw error;
  }
};

export default fetchHistoricoProdutos;
